/**************************************************
 * Nombre:       LineaDatos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../../Tema";
import {irUrl} from "../../../../Utilidades/irUrl";


const LineaDatos = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            onClick={() => irUrl(item.url)}
            sx={{
                borderBottom: 1, borderColor: '#00000050', pb: 1, pt: 1,
                color: '#000',
                cursor: 'pointer',
                '&:hover': {
                    color: theme.palette.primary.main
                }

            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 14, fontWeight: 600}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 14, fontWeight: 400, lineHeight: 1.1}}>
                    {item.descripcion}
                </Typography>
            </Grid>


        </Grid>
    )

}
export default LineaDatos